<template>
  <div>
    <template v-if="match.teams[match.info.home.key].position_grid">
      <div class="center-title center"><h2 class="center">Lineup</h2></div>
      <section class="">
        <div :class="[item[1]]" v-for="item in [
          [match.info.home.key, 'sec-one'],
          [match.info.away.key, 'sec-two'],]"
          :key="item.$index">

          <div class="field-part part-top" v-if="item[1] == 'sec-one'">
            <div class="team">{{match.teams[item[0]].name}} ({{match.teams[item[0]].lineup_formation}})</div>
          </div>
          <div class="field" :class="[item[1]+'-field']">
            <div class="field-content">
              <div class="field-row" v-for="row in match.teams[item[0]].position_grid" :key="row.$index">
                <div class="field-row-content">
                  <div class="field-col" v-for="playerKey in row" :key="playerKey">
                    <div class="field-col-content">
                      <div class="jr">{{match.players[playerKey].jersey_number}}</div>
                      <div
                        class="name clickable"
                        @click="onPlayerSelected(playerKey)">
                        {{match.players[playerKey].jersey_name}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="field-part part-bottom" v-if="item[1] == 'sec-two'">
            <div class="team">{{match.teams[item[0]].name}} ({{match.teams[item[0]].lineup_formation}})</div>
          </div>

        </div>
      </section>
    </template>

    <template v-if="match.teams[match.info.home.key].bench">
      <div class="center-title center"><h2 class="center">Bench</h2></div>
      <section class="fullwidth">
        <div :class="[item[1]]" v-for="item in [
          [match.info.home.key, 'part-first'],
          [match.info.away.key, 'part-last'],]"
          :key="item.$index">
          <ul>
            <li
              v-for="playerKey in match.teams[item[0]].bench"
              :key="playerKey"
              @click="onPlayerSelected(playerKey)"
              class="clickable">
              {{match.players[playerKey].jersey_name}} ({{match.players[playerKey].jersey_number}})
            </li>
          </ul>
        </div>
      </section>
    </template>

    <template v-if="match.teams[match.info.home.key].bench">
      <div class="center-title center"><h2 class="center">All Players</h2></div>
    </template>
    <section class="fullwidth">
      <div :class="[item[1]]" v-for="item in [
        [match.info.home.key, 'part-first'],
        [match.info.away.key, 'part-last'],]"
        :key="item.$index">
        <h5>{{match.teams[item[0]]['players'].length}} players</h5>
        <div
          v-for="role in match.teamPlayersByRole(item[0])"
          v-if="role.players.length"
          :key="role.name">
          <div class="silent">{{role.name}}</div>
          <ul>
            <li v-for="playerKey in role.players" :key="playerKey">
              <span
                class="clickable"
                @click="onPlayerSelected(playerKey)">
                {{match.players[playerKey].name}} ({{match.players[playerKey].jersey_number}})
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  props: {
    match: Object
  },
  methods: {
    onPlayerSelected (playerKey) {
      this.$emit('playerSelected', playerKey)
    }
  }
}
</script>
